import AccountTransfersBilling from '../pages/account-transfers/billing';
import AccountTransfersReports from '../pages/account-transfers/reports';
import AirtimeAndDataBilling from '../pages/airtime-and-data/billing';
import AirtimeAndDataReports from '../pages/airtime-and-data/reports';
import CustomerValidationBilling from '../pages/kyc/billing';
import CustomerValidationReports from '../pages/kyc/reports';
import CustomerAuthenticationBilling from '../pages/customer-authentication/billing';
import CustomerAuthenticationReports from '../pages/customer-authentication/reports';
import CustomerEnrollmentBilling from '../pages/customer-enrollment/billing';
import CustomerEnrollmentReports from '../pages/customer-enrollment/reports';
import MerchantPaymentBilling from '../pages/merchant-payment/billing';
import MerchantPaymentReports from '../pages/merchant-payment/reports';
import OndemandBilling from '../pages/ondemand/billing';
import OperatorLookupBilling from '../pages/operator-lookup/billing';
import OperatorLookupReports from '../pages/operator-lookup/reports';
import WalletCreditsHistory from '../pages/wallet/credits-history';
import SmsBilling from '../pages/sms/billing';
import SmsReports from '../pages/sms/reports';
import PayoutBilling from '../pages/payout/billing';
import PayoutReports from '../pages/payout/reports';
import UssdBilling from '../pages/ussd/billing';
import UssdReports from '../pages/ussd/reports';
import UssdApps from '../pages/ussd/apps';
import WapBilling from '../pages/wap/billing';
import WapReports from '../pages/wap/reports';
import WapApps from '../pages/wap/apps';
import VoiceBilling from '../pages/voice/billing';
import VoiceReports from '../pages/voice/reports';
import VoiceApps from '../pages/voice/apps';
import { PORTAL_PATH } from '../../../routes/paths';

import { SubPageItem } from './interfaces';
import ActiveUserTable from '../pages/sub-accounts-management/active';
import InActiveUserTable from '../pages/sub-accounts-management/inactive';

export const walletSubpages: SubPageItem[] = [
  {
    title: 'Credits history',
    path: PORTAL_PATH.WALLET_CREDITS_HISTORY,
    render: () => <WalletCreditsHistory />,
    portalPrivilege: 'WALLET_CREDIT',
    apiPrivilege: null
  }
];
export const accountsManagementSubpages: SubPageItem[] = [
  {
    title: 'Active users',
    path: PORTAL_PATH.SUB_ACCOUNTS_MANAGEMENT_ACTIVE,
    render: () => <ActiveUserTable />,
    portalPrivilege: 'USER_MANAGEMENT',
    apiPrivilege: null
  },
  {
    title: 'Invited users',
    path: PORTAL_PATH.SUB_ACCOUNTS_MANAGEMENT_INVITED,
    render: () => <InActiveUserTable />,
    portalPrivilege: 'USER_MANAGEMENT',
    apiPrivilege: null
  }
];

export const wapSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.WAP_BILLING,
    render: () => <WapBilling />,
    portalPrivilege: 'WAP_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.WAP_REPORTS,
    render: () => <WapReports />,
    portalPrivilege: 'WAP_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Apps',
    path: PORTAL_PATH.WAP_APPS,
    render: () => <WapApps />,
    portalPrivilege: 'WAP_SETTINGS',
    apiPrivilege: null
  }
];

export const voiceSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.VOICE_BILLING,
    render: () => <VoiceBilling />,
    portalPrivilege: 'VOICE_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.VOICE_REPORTS,
    render: () => <VoiceReports />,
    portalPrivilege: 'VOICE_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Apps',
    path: PORTAL_PATH.VOICE_APPS,
    render: () => <VoiceApps />,
    portalPrivilege: 'VOICE_SETTINGS',
    apiPrivilege: null
  }
];

export const ussdSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.USSD_BILLING,
    render: () => <UssdBilling />,
    portalPrivilege: 'USSD_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.USSD_REPORTS,
    render: () => <UssdReports />,
    portalPrivilege: 'USSD_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Apps',
    path: PORTAL_PATH.USSD_APPS,
    render: () => <UssdApps />,
    portalPrivilege: 'USSD_SETTINGS',
    apiPrivilege: null
  }
];

export const smsSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.SMS_BILLING,
    render: () => <SmsBilling />,
    portalPrivilege: 'SMS_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.SMS_REPORTS,
    render: () => <SmsReports />,
    portalPrivilege: 'SMS_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const operatorLookupSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.OPERATOR_LOOKUP_BILLING,
    render: () => <OperatorLookupBilling />,
    portalPrivilege: 'OPERATOR_LOOKUP_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.OPERATOR_LOOKUP_REPORTS,
    render: () => <OperatorLookupReports />,
    portalPrivilege: 'OPERATOR_LOOKUP_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const airtimeAndDataSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.AIRTIME_AND_DATA_BILLING,
    render: () => <AirtimeAndDataBilling />,
    portalPrivilege: 'AIRTIME_AND_DATA_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.AIRTIME_AND_DATA_REPORTS,
    render: () => <AirtimeAndDataReports />,
    portalPrivilege: 'AIRTIME_AND_DATA_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const accountTransfersSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.ACCOUNT_TRANSFERS_BILLING,
    render: () => <AccountTransfersBilling />,
    portalPrivilege: 'TRANSFER_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.ACCOUNT_TRANSFERS_REPORTS,
    render: () => <AccountTransfersReports />,
    portalPrivilege: 'TRANSFER_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const ondemandSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.ONDEMAND_BILLING,
    render: () => <OndemandBilling />,
    portalPrivilege: 'ON_DEMAND_PAYMENT_AND_ACQUISITION_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const payoutSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.PAYOUT_BILLING,
    render: () => <PayoutBilling />,
    portalPrivilege: 'PAYOUT_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.PAYOUT_REPORTS,
    render: () => <PayoutReports />,
    portalPrivilege: 'PAYOUT_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const merchantPaymentSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.MERCHANT_PAYMENT_BILLING,
    render: () => <MerchantPaymentBilling />,
    portalPrivilege: 'MERCHANT_PAYMENT_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.MERCHANT_PAYMENT_REPORTS,
    render: () => <MerchantPaymentReports />,
    portalPrivilege: 'MERCHANT_PAYMENT_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const customerValidationSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.CUSTOMER_VALIDATION_BILLING,
    render: () => <CustomerValidationBilling />,
    portalPrivilege: 'CUSTOMER_VALIDATION_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.CUSTOMER_VALIDATION_REPORTS,
    render: () => <CustomerValidationReports />,
    portalPrivilege: 'CUSTOMER_VALIDATION_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const customerAuthenticationSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.CUSTOMER_AUTHENTICATION_BILLING,
    render: () => <CustomerAuthenticationBilling />,
    portalPrivilege: 'CUSTOMER_AUTHENTICATION_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.CUSTOMER_AUTHENTICATION_REPORTS,
    render: () => <CustomerAuthenticationReports />,
    portalPrivilege: 'CUSTOMER_AUTHENTICATION_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const customerEnrollmentSubpages: SubPageItem[] = [
  {
    title: 'Billing',
    path: PORTAL_PATH.CUSTOMER_ENROLLMENT_BILLING,
    render: () => <CustomerEnrollmentBilling />,
    portalPrivilege: 'CUSTOMER_ENROLLMENT_BILLING_REPORTS',
    apiPrivilege: null
  },
  {
    title: 'Reports',
    path: PORTAL_PATH.CUSTOMER_ENROLLMENT_REPORTS,
    render: () => <CustomerEnrollmentReports />,
    portalPrivilege: 'CUSTOMER_ENROLLMENT_BILLING_REPORTS',
    apiPrivilege: null
  }
];

export const dictionary: Record<string, SubPageItem[]> = {
  [PORTAL_PATH.WALLET]: walletSubpages,
  [PORTAL_PATH.USSD]: ussdSubpages,
  [PORTAL_PATH.SMS]: smsSubpages,
  [PORTAL_PATH.OPERATOR_LOOKUP]: operatorLookupSubpages,
  [PORTAL_PATH.AIRTIME_AND_DATA]: airtimeAndDataSubpages,
  [PORTAL_PATH.ACCOUNT_TRANSFERS]: accountTransfersSubpages,
  [PORTAL_PATH.ONDEMAND]: ondemandSubpages,
  [PORTAL_PATH.PAYOUT]: payoutSubpages,
  [PORTAL_PATH.MERCHANT_PAYMENT]: merchantPaymentSubpages,
  [PORTAL_PATH.CUSTOMER_VALIDATION]: customerValidationSubpages,
  [PORTAL_PATH.CUSTOMER_AUTHENTICATION]: customerAuthenticationSubpages,
  [PORTAL_PATH.CUSTOMER_ENROLLMENT]: customerEnrollmentSubpages
};
